import React, { useState, useEffect } from 'react';
import AliceCarousel from 'react-alice-carousel';

import { BaseGym } from '../../types/Gym';
import { ExtraGym as ExtraGymType } from '../../types/ExtraGym';

import { ExtraGym } from './ExtraGym';
import { PromoItem } from './PromoItem';

import { fetchExtraGyms } from '../../services/api/fetchExtraGym';

import styles from './ExtraGyms.module.scss';

export type ExtraGymsProps = {
  gym: BaseGym;
};

export const ExtraGyms: React.FC<ExtraGymsProps> = ({ gym }) => {
  const [responsive, setResponsive] = useState({});
  const [gyms, setGyms] = useState<ExtraGymType[]>([]);

  // responsive layout needs to be stored in state for the alice carousel
  // plugin to render the items correctly when using the infinite prop
  useEffect(() => {
    const responsiveLayout = {
      0: { items: 1 },
      767: { items: 4 },
      1199: { items: 4 },
    };

    setResponsive(responsiveLayout);
  }, []);

  useEffect(() => {
    (async () => {
      const extraGyms = await fetchExtraGyms(gym.id, String(gym.monthly_price));
      setGyms(extraGyms);
    })();
  }, [gym.id, gym.monthly_price]);

  const gymItems = gyms.map((item, index) => <ExtraGym key={index} gym={item} />);

  const promoItem = <PromoItem />;
  const promoPosition = 3;
  const compiledItems = [...gymItems.slice(0, promoPosition), promoItem, ...gymItems.slice(promoPosition)];

  return (
    <div className={styles.extragyms}>
      <h3>This monthly membership also includes</h3>
      <p className={styles.extragyms__subheading}>
        Your membership also includes access to all other amazing venues at this price point and below plus online
        classes and virtual workouts for ultimate flexibility.
      </p>
      <div className={styles.extragyms__carousel}>
        <AliceCarousel
          disableDotsControls
          autoPlay={false}
          responsive={responsive}
          mouseTracking
          items={compiledItems}
          infinite
          renderNextButton={() => {
            return <div className={styles['extragyms__carousel-next']}>&gt;</div>;
          }}
          renderPrevButton={() => {
            return <div className={styles['extragyms__carousel-previous']}>&lt;</div>;
          }}
        />
      </div>
    </div>
  );
};
